import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, setToken, getToken, formatError } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = guest, object = signed-in
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!getToken()) { setUser(false); return; }
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch {
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post('/auth/login', { email, password });
      setToken(data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: formatError(err) };
    }
  };

  const logout = () => {
    setToken(null);
    setUser(false);
    window.location.href = '/crm/login';
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
